export default __webpack_public_path__ + "static/media/rocket.21674e85.gif";